module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-onslaught.4fd472fe.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-top-onslaught.png
// module id = 2849
// module chunks = 11